








































import Api from "./Api";
import {Component, Inject, Prop, Watch} from "vue-property-decorator";
import CompanyUserRequired from "../../CompanyRequired";
import {CardExpirationReportRow} from "@/components/users/reports/CardExpirationReportModel";
import {Company, DateTime} from "@/modules/models";
import rd from "@/modules/vRoutedefs";
import DatePicker from "@/components/DatePicker.vue";

@Component({
  components: {
    "at-date-picker": DatePicker,
  }
})
export default class CardExpirationReportLocations extends CompanyUserRequired {
    @Inject()
    api!: Api;
    @Prop({default: () => DateTime.now().dayOffset(7*5)} /* default is 5 weeks in the future */)
    maxExpiration!: DateTime;
    @Prop({default: () => DateTime.now().dayOffset(-7)} /* default is one week ago */)
    minTimeIn!: DateTime;

    get maxEx() {
      return this.maxExpiration;
    }
    set maxEx(v: DateTime) {
      if(!v.equals(this.maxExpiration)) {
        this.$router.push({ path: rd.users.reports.cardexpirationcompany.path, query: {"max-expiration": v.toDayParam(), "min-time-in": this.minTimeIn.toDayParam()} });
      }
    }
    get minTim() {
      return this.minTimeIn;
    }
    set minTim(v: DateTime) {
      if(!v.equals(this.minTimeIn)) {
        this.$router.push({ path: rd.users.reports.cardexpirationcompany.path, query: {"max-expiration": this.maxExpiration.toDayParam(), "min-time-in": v.toDayParam()} })
      }
    }

    loading = false;

    headers = [
        {"text": "Kortnr", value: "cardNum", align: "left"},
        {"text": "Utløpsdato", value: "expirationDate", align: "left"},
        {"text": "Firma", value: "cardCompany", align: "left"},
        {"text": "Fornavn", value: "firstName", align: "left"},
        {"text": "Etternavn", value: "lastName", align: "left"},
        {"text": "Mobilnr", value: "phone", align: "left"},
        {"text": "Sist innregistrert", value: "lastTimeIn", align: "left"},
        {"text": "Anlegg", value: "terminalLocation", align: "left"},
    ];

    items: CardExpirationReportRow[] = [];

    pagination = {
        rowsPerPage: -1,
        sortBy: "lastName"
    };

  @Watch("minTim")
  @Watch("maxEx")
  async loadResult() {
        this.loading = true;
        try {
            this.items = await this.api.fetchCardExpirationReportCompanyCards(this.company.orgNum, this.maxExpiration, this.minTimeIn);
        } catch (err) {
            this.emitError(err);
        } finally {
            this.loading = false;
        }
    }

    expirationClass(expirationDate: DateTime) {
        if(expirationDate.isBefore(DateTime.now())) {
            return "error--text";
        } else {
            return "warning--text";
        }
    }

    userTo(personGuid: string) {
        return {name: rd.users.name, query: {guid: personGuid}};
    }

    created() {
        this.loadResult();
    }
}
